// Cycle 361 → 473.1 — THE predicate for "an alarm outranks an overlay".
//
// Cycle 361 wrote it inline for the medication-reminder takeover. Cycle 473.1
// (the operator's decision, 2026-11-03) made the kiosk's system Wi-Fi gate
// and its foreign-prompt bounce read the SAME rule, so it lives here as one
// pure function both call sites use.
//
// An alarm counts when EITHER:
//   (1) it can actually SOUND — `audioOn` (`phase === "active" && !silenced`),
//       at ANY level; or
//   (2) a LOW-SIDE episode is live at all, muted or not — `isLive && lowSide`,
//       where `lowSide` is the shared cycle-311.1 `episodeLowSide` predicate
//       (passed in, never re-derived: every alarm-gated surface reuses it).
//
// A Stopped or snoozed HIGH does NOT count: on the measured account a high
// sat muted-but-live for a median 5.3 h (cycle 361), the server cannot
// recover it while a kiosk is offline, and gating the Wi-Fi screens on it
// would leave a travelling tablet unable to get online (the operator,
// 2026-11-03). "Lows kill — Highs do not."

export interface OverlayAlarmInput {
  /** `episode.audioOn`: the alarm can sound right now, any level. */
  audioOn: boolean;
  /** `episode.isLive`: active or snoozed. */
  isLive: boolean;
  /** The shared cycle-311.1 `episodeLowSide` (current OR opening level low-side). */
  lowSide: boolean;
}

export function alarmOutranksOverlay(i: OverlayAlarmInput): boolean {
  return i.audioOn || (i.isLive && i.lowSide);
}
